// extracted by mini-css-extract-plugin
export var logo = "_bt-2";
export var logoWrapper = "_bt-1";
export var strip = "_bt-0";